import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth";
import loading from "./loading";
import mypage from "./mypage";
import delivery from "./delivery";
import report from "./report";

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        auth,
        loading,
        mypage,
        delivery,
        report
    },
    plugins: [createPersistedState(
        {
            key: 'storageReserveNo',
            paths: ['mypage.reserveNo','report.play_date'],
            storage: window.sessionStorage
        }
    )]
});

export default store;
